<template>
  <b-nav-item v-if="isVisible" :to="{ name: 'ManageBDX' }">
    <b-icon-exclamation-triangle
      class="text-danger"
    ></b-icon-exclamation-triangle>
  </b-nav-item>
</template>

<script>
import Vue from 'vue'
import { defineComponent, computed, ref, onMounted } from '@vue/composition-api'

import { useCurrentUser, useUserCompany } from '@composables'
import { LincolnNewGlobalUMRService } from '@services'

export default defineComponent({
  name: 'NewBDXIconNavItem',
  setup() {
    const { isSuperUser } = useCurrentUser()
    const { id: companyId } = useUserCompany()

    const isVisible = computed(() => {
      if (isSuperUser.value || !companyId.value) return false

      return hasNewBDXItems.value
    })

    const hasNewBDXItems = ref(false)

    const checkNewBDXItems = async () => {
      if (!companyId.value) return

      try {
        const { data } = await LincolnNewGlobalUMRService.check(companyId.value)
        const { data: results } = data || {}

        hasNewBDXItems.value = results.exists
      } catch (_) {
        hasNewBDXItems.value = false
      }
    }

    onMounted(async () => {
      await checkNewBDXItems()

      Vue.prototype.$emitter.on('files-uploaded', async ({ type, success }) => {
        if (!success || 'bdx' !== type) return

        await checkNewBDXItems()
      })
    })

    return {
      companyId,

      isVisible,

      hasNewBDXItems
    }
  }
})
</script>
